export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-0 rounded-[32px] overflow-hidden border border-background-200/70">
          <div className="w-full lg:w-[45%] relative overflow-hidden min-h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20desk%20with%20warm%20ambient%20lighting%2C%20news%20tips%20and%20reports%20scattered%20artistically%2C%20coral%20and%20gold%20warm%20tone%20palette%2C%20professional%20journalism%20aesthetic%2C%20clean%20minimal%20composition%2C%20soft%20shadows&width=800&height=640&seq=contact-submit-bg&orientation=landscape"
              alt="爆料投稿"
              title="51吃瓜网 爆料投稿通道"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block text-xs font-label tracking-wider text-accent-300 bg-accent-900/30 px-4 py-1.5 rounded-full mb-3 whitespace-nowrap">
                爆料通道
              </span>
              <div className="font-heading text-[28px] md:text-[34px] text-background-50 leading-tight">
                有料要爆？直接联系51吃瓜网
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[55%] bg-background-50 p-8 md:p-12 flex flex-col justify-center">
            <h2 className="font-heading text-[28px] md:text-[34px] text-foreground-950 mb-4">爆料投稿</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
              你手上有独家八卦、热门线索或内幕消息？51吃瓜网欢迎广大吃瓜群众积极投稿爆料。优质独家内容一经采用，将获得丰厚奖励，并有机会成为我们的签约爆料人。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#footer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#footer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                提交爆料
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="mailto:tips@51chigua.com"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-800 font-medium text-sm rounded-full hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
              >
                邮件投稿
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}